import logger from '../logger';

export const getSanitizedReturnTo = (
  returnTo?: string,
  url?: string,
): string | undefined => {
  try {
    // eslint-disable-next-line no-param-reassign
    returnTo = returnTo && atob(returnTo);
  } catch (error) {
    logger.info(
      'There was an error while trying to decode the returnTo parameter. Will continue as usual.',
      error,
    );
  }

  if (returnTo?.startsWith('//')) return undefined;

  if (!returnTo || returnTo.startsWith('/')) return returnTo;

  if (!url?.length) return undefined;

  if (!returnTo.startsWith(url)) return undefined;

  const sanitizedReturnTo = returnTo.slice(url.length);
  return sanitizedReturnTo.startsWith('/')
    ? sanitizedReturnTo
    : `/${sanitizedReturnTo}`;
};
